const {getSiteInCluster} = require("../clusters");
const shopExists = (shop, domain) => {
  const siteInCluster = getSiteInCluster(domain);
  return !!siteInCluster.envs?.[shop];
};

module.exports = {
  shopExists,
};
